<template>
    <SlideOver size="xxl" :show="open" @close="dismiss()" :title="category.name">
        <div class="flex space-x-2">
            <img
                :alt="student.full_name"
                :title="student.full_name"
                class="h-6 w-6 rounded-full"
                :src="student.avatar_or_default"
            />
            <div>{{ student.full_name }}</div>
        </div>
        <form action="/" @submit.prevent="submit" id="final_trimester_grades_form">
            <div class="flex flex-col mt-5">
                <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                    <div
                        class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                    >
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead>
                                <tr>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        -
                                    </th>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider hidden xl:block"
                                    >
                                        {{ $tc('messages.dimensions', 1) }}
                                    </th>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.calculated') }}
                                    </th>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.manual_score') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                    v-for="(dimension, index) in form.grades"
                                    :key="dimension.dimension_id"
                                >
                                    <td class="px-6 py-1 whitespace-nowrap text-sm leading-5">
                                        {{ dimension.abbreviation }}
                                    </td>
                                    <td
                                        class="px-6 py-1 whitespace-nowrap text-sm leading-5 text-gray-500 hidden xl:block"
                                    >
                                        {{ dimension.title }}
                                    </td>
                                    <td
                                        class="px-6 py-1 whitespace-nowrap text-sm leading-5"
                                        :class="dimension.classes"
                                    >
                                        {{ dimension.score }}
                                    </td>
                                    <td class="px-6 py-1 whitespace-nowrap text-sm leading-5 text-gray-500">
                                        <div class="flex items-center">
                                            <div class="mt-1 relative rounded-md shadow-sm">
                                                <input
                                                    v-model.number="dimension.decimal_score"
                                                    type="number"
                                                    step="0.01"
                                                    max="10"
                                                    min="0"
                                                    :tabindex="index + 2"
                                                    :ref="`dimension_${index}`"
                                                    :id="`dimension_${index}`"
                                                    class="invalid:border-red-500 disable-input-arrows max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                                                    style="min-width: 70px"
                                                />
                                                <div
                                                    class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                                                >
                                                    <span class="xhidden xl:inline-block">/ 10</span>
                                                </div>
                                            </div>
                                        </div>
                                        <FormError :value="form.errors[`grades.${index}.decimal_score`]" class="mt-2" />
                                    </td>
                                </tr>
                            </tbody>
                            <thead>
                                <tr>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        -
                                    </th>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider hidden xl:block"
                                    >
                                        -
                                    </th>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.calculated') }}
                                    </th>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.manual_score') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="bg-white">
                                    <td class="px-6 py-4 whitespace-nowrap text-sm leading-5">-</td>
                                    <td
                                        class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 hidden xl:block"
                                    >
                                        {{ $t('messages.global') }}
                                    </td>
                                    <td
                                        class="px-6 py-4 whitespace-nowrap text-sm leading-5"
                                        :class="form.global.classes"
                                    >
                                        {{ form.global.score }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                        <div class="flex items-center">
                                            <div class="mt-1 relative rounded-md shadow-sm">
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    max="10"
                                                    v-model.number="form.global.decimal_score"
                                                    min="0"
                                                    id="dimension_global"
                                                    class="invalid:border-red-500 disable-input-arrows max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                                                    style="min-width: 70px"
                                                />
                                                <div
                                                    class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                                                >
                                                    <span class="xhidden xl:inline-block">/ 10</span>
                                                </div>
                                            </div>
                                        </div>
                                        <FormError :value="form.errors[`global.decimal_score`]" class="mt-2" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="flex justify-end">
                <div class="mt-1">
                    <FormLabel :value="$t('messages.is_not_graded')" for="is_not_graded">
                        <input
                            id="is_not_graded"
                            type="checkbox"
                            v-model="form.global.is_not_graded"
                            name="is_not_graded"
                            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        />
                    </FormLabel>
                    <FormError :value="form.errors.is_not_graded" class="mt-2" />
                </div>
            </div>

            <div class="sm:col-span-12">
                <div class="mt-1">
                    <FormLabel :value="$t('messages.comment')" for="comment" />
                    <FormTextarea id="comment" v-model="form.global.comment" name="comment" type="text" class="mt-1" />
                    <FormError :value="form.errors[`global.comment`]" class="mt-2" />
                </div>
            </div>
            <div v-if="aiEnabled && commentStartsEmpty">
                <FinalTrimesterGradesFormAiComment
                    v-model="form.global.comment"
                    :grades="form.grades"
                    :student="student"
                    :category-id="category.id"
                />
            </div>
        </form>
        <template v-slot:bottom>
            <div class="flex justify-end" v-if="canEdit">
                <SubmitFormButton
                    :button-text="$t('messages.save')"
                    :processing="form.processing"
                    form="final_trimester_grades_form"
                />
            </div>
        </template>
    </SlideOver>
</template>

<script>
import FormError from '@/components/Forms/FormError.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';
import SlideOver from '@/components/SlideOver.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import FinalTrimesterGradesFormAiComment from '@/components/FinalTrimesterGradesFormAiComment.vue';

export default {
    emits: ['close'],
    name: 'FinalTrimesterGradesFormPanel',
    components: {
        FinalTrimesterGradesFormAiComment,
        SubmitFormButton,
        SlideOver,
        FormError,
        FormLabel,
        FormTextarea,
    },

    props: {
        student: {
            required: true,
            type: Object,
        },
        categoryGrades: {
            required: true,
            type: Object,
        },
        category: {
            required: true,
            type: Object,
        },
        selector: {
            required: true,
        },
        canEdit: {
            required: true,
            type: Boolean,
        },
        aiEnabled: {
            required: true,
            type: Boolean,
        },
    },

    data() {
        return {
            open: false,
            commentStartsEmpty: !this.categoryGrades.global.final.comment,
            form: this.$inertia.form({
                grades: this.getGradesTable(),
                global: {
                    score: this.categoryGrades.global.score,
                    letter: this.categoryGrades.global.letter,
                    classes: this.categoryGrades.global.classes,
                    category_id: this.categoryGrades.id,
                    decimal_score: this.categoryGrades.global.final.score,
                    comment: this.categoryGrades.global.final.comment,
                    is_not_graded: this.categoryGrades.global.final.is_not_graded,
                },
            }),
        };
    },
    methods: {
        getGradesTable() {
            return this.category.dimensions.map((d) => {
                const dimensionScore = this.getDimensionGrade(d.id);
                const decimalScore = dimensionScore.final?.score;
                return {
                    score: dimensionScore.score,
                    letter: dimensionScore.letter,
                    classes: dimensionScore.classes,
                    dimension_id: d.id,
                    title: d.title,
                    abbreviation: d.abbreviation,
                    decimal_score: typeof decimalScore !== 'undefined' ? decimalScore : null,
                };
            });
        },
        getDimensionGrade(id) {
            return this.categoryGrades.dimensions.find((d) => d.id == id);
        },
        dismiss() {
            this.open = false;
            this.$emit('close');
        },
        submit() {
            this.form.patch(this.student.update_grades_url, {
                preserveScroll: true,
                onSuccess: () => {
                    this.dismiss();
                    this.form.reset('grades');
                },
            });
        },
    },
    watch: {
        student: {
            immediate: true,
            handler: function (value) {
                if (value !== null) {
                    this.open = true;
                }
                this.$nextTick(function () {
                    let selector = this.selector;
                    document.getElementById(selector).focus();
                });
            },
        },
    },
};
</script>
